import { render, staticRenderFns } from "./InstagramStoryReply.vue?vue&type=template&id=57336140&"
import script from "./InstagramStoryReply.vue?vue&type=script&lang=js&"
export * from "./InstagramStoryReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports